import facepaint from 'facepaint'
import theme from '../configs/accdotcom.theme'

const sizes = ['sm', 'md', 'lg', 'xl']
const breakpoints = sizes.map(size => theme.breakpoints[size])
export const mq = facepaint(breakpoints.map(bp => `@media (min-width: ${bp})`))

export default mq
